/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum MessageTypes {
    Information = 1,
    Success = 2,
    Warning = 4,
    Error = 8,
}
